import LoggerFactory from '../../Util/Logger/LoggerFactory';

import { ApiBooking, ApiCustomerFromJSON, ApiTraveler, ApiTravelerFromJSON } from '@ibe/api';
import clone from '../../Util/clone';
abstract class MaskBookingService {
  private logger = LoggerFactory.get('BookingService');

  public static maskBooking(booking: ApiBooking | null): ApiBooking {
    const maskedBooking = clone(booking) as ApiBooking;
    if (booking?.client) {
      maskedBooking.client = ApiCustomerFromJSON({
        type: booking.client.type,
        id: booking.client.id
      });
    }
    if (booking?.travelers) {
      const maskedTravelers: ApiTraveler[] = [];
      booking.travelers.map(t => {
        const maskedTraveler = ApiTravelerFromJSON({ id: t.id, type: t.type });
        maskedTravelers.push(maskedTraveler);
      });
      maskedBooking.travelers = maskedTravelers;
    }

    return maskedBooking;
  }

  public static maskBookingWithClient(booking: ApiBooking | null): ApiBooking {
    const maskedBooking = clone(booking) as ApiBooking;
    if (booking?.client) {
      maskedBooking.client = ApiCustomerFromJSON(booking.client);
    }
    if (booking?.travelers) {
      const maskedTravelers: ApiTraveler[] = [];
      booking.travelers.map(t => {
        const maskedTraveler = ApiTravelerFromJSON({ id: t.id, type: t.type });
        maskedTravelers.push(maskedTraveler);
      });
      maskedBooking.travelers = maskedTravelers;
    }

    return maskedBooking;
  }
}

export default MaskBookingService;
